import { getFreeMonthlyCredits } from '@shared/utilities';
import useFeature from '~/hooks/useFeature';

/**
 * Free monthly API credits for the current user, from the `api_free_credits` feature flag.
 * Prefer `credits.monthly_credits` from `/api-access` when available (it includes manual overrides).
 */
export function useFreeMonthlyCredits(): number {
  const [enabled, variables] = useFeature('api_free_credits');
  return getFreeMonthlyCredits({ enabled, variables });
}
